var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.98357 6.50683L12.178 2.31241C12.5945 1.89586 13.2711 1.89586 13.6876 2.31241C14.1041 2.72895 14.1041 3.40547 13.6876 3.82201L9.49317 8.01643L13.6876 12.2108C14.0954 12.6177 14.0954 13.2797 13.6876 13.6876C13.2797 14.0954 12.6177 14.0954 12.2108 13.6876L8.01643 9.49317L3.82201 13.6876C3.40547 14.1041 2.72895 14.1041 2.31241 13.6876C1.89586 13.2711 1.89586 12.5945 2.31241 12.178L6.50683 7.98357L2.31241 3.78915C1.90456 3.38227 1.90456 2.72025 2.31241 2.31241C2.72025 1.90456 3.38227 1.90456 3.78915 2.31241L7.98357 6.50683Z",
  fill: "currentColor"
})));
export { SvgClose as ReactComponent };